import { usePackageByTypeAndPackageId, useProjectId } from '@consigli/hooks';
import { DocumentPackageType } from '@consigli/types';
import { FC } from 'react';
import { Outlet, useParams } from 'react-router';

import { Breadcrumb } from '@/features/breadcrumb/breadcrumb';
import { DocumentListProvider } from '@/features/document-list/document-list-context';

export const LuminaireScheduleDetailWrapper: FC = () => {
  const projectId = useProjectId();
  const { packageId } = useParams<{ packageId: string }>();

  const { pkg } = usePackageByTypeAndPackageId(
    projectId,
    DocumentPackageType.LUMINAIRE_SCHEDULE,
    packageId!,
  );

  return (
    <>
      <Breadcrumb label={pkg?.name ?? ''} />
      <DocumentListProvider>
        <Outlet />
      </DocumentListProvider>
    </>
  );
};
